import { useMemo } from "react";

// Canonical accessor for "are we running inside the Expo BottomTabWebview?".
// The Expo app sets `window.isInApp = true` on the webview document before
// it loads the FE bundle (see sotravel-expo/src/components/BottomTabWebview.tsx).
//
// Use this hook in new code instead of reading `window.isInApp` directly so
// SSR/test contexts get a safe `false` and so the access point is greppable.
// Existing direct callers (Book.js:59, authAxios.js, utils/constants.js x2)
// are intentionally NOT migrated — this hook is forward-only.
export function useIsInApp() {
  return useMemo(() => typeof window !== "undefined" && Boolean(window.isInApp), []);
}
